<template>
  <div class="users-opening-balance-box">
    <draggable-dynamic-table ref="usersOpeningBalanceList"
                             :in-modal="true"
                             :fix-screen="true"
                             :active-grid="true"
                             :options="options"
                             :columns="columnsLabel"
                             @row:clicked="handleRowClicked($event)"
                             @load:more="getUsersOpeningBalance"
                             v-model="data"/>

    <!-- insert users opening balance prompt -->
    <vs-prompt
      class="big-prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="insertOpeningInventoryPromptStatus"
      @close="insertOpeningInventoryPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('saveBTN')">
              <custom-icon icon="SAVE" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
             {{ $t('users.openingBalance.insert.title', {type: type === 'debtor' ? this.$t('users.openingBalance.type.debtor') : this.$t('users.openingBalance.type.creditor')}) }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="insertOpeningInventoryPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content p-2">
        <insert-users-opening-balance :type="type"/>
      </div>

    </vs-prompt>

    <!-- edit users opening balance prompt -->
    <vs-prompt
      class="prompt p-0"
      :buttons-hidden="true"
      title=""
      :active.sync="editOpeningInventoryPromptStatus"
      @close="editOpeningInventoryPromptStatus = true">

      <div class="prompt-header p-3 w-full" :class="[!this.$vs.rtl ? 'rtl-only' : '']">
        <vs-row>
          <vs-col class="w-1/5 useral-font-weight-medium text-success cursor-pointer">
            <div @click="handleClick('saveBTN')">
              <custom-icon icon="SAVE" color="success"/>
            </div>
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/2 text-center useral-font-weight-bold text-md">
            {{ $t('users.openingBalance.edit.title', {user: selectedUser.name}) }}
          </vs-col>

          <vs-spacer/>

          <vs-col class="w-1/5 text-right useral-font-weight-medium text-danger cursor-pointer">
            <div @click="editOpeningInventoryPromptStatus = false">
              <custom-icon icon="TIMES-CIRCLE" color="danger"/>
            </div>
          </vs-col>
        </vs-row>
      </div>

      <div class="prompt-content p-2">
        <edit-users-opening-balance :type="type" :user="selectedUser"/>
      </div>

    </vs-prompt>

    <button id="InsertOpeningInventoryBTN" class="useral-action-button"
            @click="insertOpeningInventoryPromptStatus = true"></button>
  </div>
</template>

<script>
import axios from 'axios'
import {
  getCreditorUsersOpeningInventories,
  getDebtorUsersOpeningInventories
} from '@/http/requests/openingInventories'
import {addComma} from '@/assets/js/functions'
import SelectUsers from '@/views/admin/customers/select/selectUsers'
import InsertUser from '@/views/admin/customers/insert/insertUser'
import InsertUsersOpeningBalance from './insertUsersOpeningBalance'
import {
  deleteCreditorUsersOpeningInventories,
  deleteDebtorUsersOpeningInventories, getCreditorUserOpeningInventories, getDebtorUserOpeningInventories
} from '../../../../http/requests/openingInventories'
import CustomIcon from '../../../../components/customIcon/customIcon'
import EditUsersOpeningBalance from './editUsersOpeningBalance'

export default {
  name: 'usersOpeningBalance',
  components: {EditUsersOpeningBalance, CustomIcon, InsertUsersOpeningBalance, InsertUser, SelectUsers},
  data () {
    return {
      requestSent: false,
      insertOpeningInventoryPromptStatus: false,
      editOpeningInventoryPromptStatus: false,
      page: 1,
      endedList: false,
      loadingTimer: 0,
      options: {
        rowKeyField: 'id'
      },
      columnsLabel: [
        /*{
          field: 'delete',
          headerName: 'حذف',
          width: '70px',
          minWidth: 70,
          /!*sortable: true,*!/
          actions: true,
          showAction: 'always',
          action: {
            color: 'danger',
            icon: 'icon-trash',
            iconPack: 'feather',
            type: 'button'
          },
          event: 'row:deleted'
        },*/
        {
          field: 'price',
          i18n: 'users.openingBalance.list.table.header.price',
          width: '50%',
          minWidth: 200,
          /*sortable: true,*/
          // editable: true,
          // returnValue: true,
          // valueType: 'price',
          align: 'center',
          footer: {
            type: 'auto-sum',
            textType: 'price'
          }
        },
        {
          field: 'name',
          i18n: 'users.openingBalance.list.table.header.name',
          align: 'center',
          width: '50%',
          minWidth: 200
          /*sortable: true,*/
          // editable: true,
          // returnValue: false,
          // suggest: true,
          // suggestPrompt: true,
        },
        {
          field: 'rowNumber',
          i18n: 'users.openingBalance.list.table.header.rowNumber',
          align: 'center',
          width: '70px',
          minWidth: 70,
          // sortable: true,
          footer: {}
        }
      ],
      data: [],
      selectedUser: {}
    }
  },
  created () {
    this.getUsersOpeningBalance()
    this.checkOpeningBalanceStatus()
  },
  props: {
    type: {
      type: String
    }
  },
  methods: {
    getUsersOpeningBalance () {
      if (!this.requestSent) {
        this.requestSent = true

        clearTimeout(this.loadingTimer)
        this.loadingTimer = setTimeout(() => {
          if (!this.endedList) {
            if (this.$refs.usersOpeningBalanceList && this.data.length === 0) this.$refs.usersOpeningBalanceList.loadMoreStatus = 'FirstLoad'
            else if (this.$refs.usersOpeningBalanceList && this.data.length > 0) this.$refs.usersOpeningBalanceList.loadMoreStatus = 'Loading'

            if (this.type === 'debtor') {
              getDebtorUsersOpeningInventories(this.page).then(response => {
                const users = response.data.data

                this.total_count = response.data.pagination.total

                users.forEach((user) => {
                  this.data.push({
                    rowNumber: this.total_count - this.data.length,
                    id: user.id,
                    name: `${user.name} ${user.family}`,
                    price: addComma(user.price),
                    flag: 'SAVED'
                  })
                })

                this.page = response.data.pagination.current_page + 1
                if (response.data.pagination.current_page === 1) {
                  const row_index = this.columnsLabel.map((e) => {
                    return e.field
                  }).indexOf('rowNumber')
                  this.columnsLabel[row_index].footer = {value: response.data.pagination.total}
                }

                if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.loadMoreStatus = ''

                this.requestSent = false
              }).catch((error) => {
                if (axios.isCancel(error)) {
                  this.$vs.notify({
                    title: this.$t('alert.duplicateRequest.title'),
                    text: this.$t('alert.duplicateRequest.message'),
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: 2400,
                    color: 'warning'
                  })
                } else {

                  if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.loadMoreStatus = 'Danger'

                  this.requestSent = false
                }
              })
            } else {
              getCreditorUsersOpeningInventories(this.page).then(response => {
                const users = response.data.data

                this.total_count = response.data.pagination.total

                users.forEach((user) => {
                  this.data.push({
                    rowNumber: this.total_count - this.data.length,
                    id: user.id,
                    name: `${user.name} ${user.family}`,
                    price: addComma(user.price < 0 ? user.price * -1 : user.price),
                    flag: 'SAVED'
                  })
                })

                this.page = response.data.pagination.current_page + 1
                if (response.data.pagination.current_page === 1) {
                  const row_index = this.columnsLabel.map((e) => {
                    return e.field
                  }).indexOf('rowNumber')
                  this.columnsLabel[row_index].footer = {value: response.data.pagination.total}
                }

                if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.loadMoreStatus = ''

                this.requestSent = false
              }).catch((error) => {
                if (axios.isCancel(error)) {
                  this.$vs.notify({
                    title: this.$t('alert.duplicateRequest.title'),
                    text: this.$t('alert.duplicateRequest.message'),
                    icon: 'icon-alert-circle',
                    iconPack: 'feather',
                    time: 2400,
                    color: 'warning'
                  })
                } else {

                  if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.loadMoreStatus = 'Danger'

                  this.requestSent = false
                }
              })
            }
          } else {

            this.requestSent = false
          }
        }, 400)
      }
    },
    handleDeleteRow (row) {
      if (row) {
        const index = this.data.map((elm) => {
          return elm.id
        }).indexOf(row.id)
        if (index > -1 && row.id !== 0) {

          if (this.type === 'debtor') {
            deleteDebtorUsersOpeningInventories(row.id).then(() => {
              this.$vs.notify({
                title: this.$t('users.openingBalance.edit.notifications.debtor.delete.success.title'),
                text: this.$t('users.openingBalance.edit.notifications.debtor.delete.success.message'),
                color: 'success',
                time: 2400,
                icon: 'icon-check',
                iconPack: 'feather'
              })

              this.data.splice(index, 1)
              this.$store.dispatch('helper/changeOpeningBalance')
            }).catch((error) => {
              if (axios.isCancel(error)) {
                this.$vs.notify({
                  title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400,
                  color: 'warning'
                })
              } else {
                this.$vs.notify({
                  title: this.$t('users.openingBalance.edit.notifications.debtor.delete.error.title'),
                  text: this.$t('users.openingBalance.edit.notifications.debtor.delete.error.message'),
                  color: 'danger',
                  time: 2400,
                  icon: 'icon-alert-circle',
                  iconPack: 'feather'
                })
              }
            })
          } else {
            deleteCreditorUsersOpeningInventories(row.id).then(() => {
              this.$vs.notify({
                title: this.$t('users.openingBalance.edit.notifications.creditor.delete.success.title'),
                text: this.$t('users.openingBalance.edit.notifications.creditor.delete.success.message'),
                color: 'success',
                time: 2400,
                icon: 'icon-check',
                iconPack: 'feather'
              })

              this.data.splice(index, 1)
              this.$store.dispatch('helper/changeOpeningBalance')
            }).catch((error) => {
              if (axios.isCancel(error)) {
                this.$vs.notify({
                  title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
                  icon: 'icon-alert-circle',
                  iconPack: 'feather',
                  time: 2400,
                  color: 'warning'
                })
              } else {
                this.$vs.notify({
                  title: this.$t('users.openingBalance.edit.notifications.creditor.delete.error.title'),
                  text: this.$t('users.openingBalance.edit.notifications.creditor.delete.error.message'),
                  color: 'danger',
                  time: 2400,
                  icon: 'icon-alert-circle',
                  iconPack: 'feather'
                })
              }
            })
          }
        }
      }
    },
    handleRowClicked (item) {
      if (!this.$store.state.helper.openingBalanceLocked) {
        this.selectedUser = item
        this.editOpeningInventoryPromptStatus = true
      }
    },
    handleClick (id) {
      document.getElementById(id).click()
    },
    checkOpeningBalanceStatus () {
      if (this.$store.state.helper.openingBalanceLocked) {
        const mapper = this.columnsLabel.map(elm => {
          return elm.field
        })

        const name_index = mapper.indexOf('name')
        this.columnsLabel[name_index].editable = false
        this.columnsLabel[name_index].suggest = false
        this.columnsLabel[name_index].suggestPrompt = false

        const price_index = mapper.indexOf('price')
        this.columnsLabel[price_index].editable = false

        const action_index = mapper.indexOf('delete')
        this.columnsLabel.splice(action_index, 1)
      }
    },
    refreshUserDetails () {
      if (this.type === 'debtor') {
        getDebtorUserOpeningInventories(this.selectedUser.id).then(response => {
          const user = response.data.data
          const user_index = this.data.map(elm => {
            return elm.id
          }).indexOf(user.id)

          if (user_index >= 0) {
            this.data[user_index] = {
              rowNumber: this.data[user_index].rowNumber,
              id: user.id,
              name: `${user.name} ${user.family}`,
              price: addComma(user.price),
              flag: 'SAVED'
            }

            if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.setTableData()
          }
        })
      } else {
        getCreditorUserOpeningInventories(this.selectedUser.id).then(response => {
          const user = response.data.data
          const user_index = this.data.map(elm => {
            return elm.id
          }).indexOf(user.id)

          if (user_index >= 0) {
            this.data[user_index] = {
              rowNumber: this.data[user_index].rowNumber,
              id: user.id,
              name: `${user.name} ${user.family}`,
              price: addComma(user.price < 0 ? user.price * -1 : user.price),
              flag: 'SAVED'
            }

            if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.setTableData()
          }
        })
          .catch(error => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            }
          })
      }
    },
    deleteUserDetails () {
      const user_index = this.data.map(elm => {
        return elm.id
      }).indexOf(this.selectedUser.id)
      if (user_index >= 0) this.data.splice(user_index, 1)

      if (this.type === 'debtor') {
        getDebtorUsersOpeningInventories(1).then(response => {
          if (response.data.pagination.current_page === 1) {
            const row_index = this.columnsLabel.map((e) => {
              return e.field
            }).indexOf('rowNumber')
            this.columnsLabel[row_index].footer = {value: response.data.pagination.total}
          }
        })
          .catch(error => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            }
          })
      } else {
        getCreditorUsersOpeningInventories(1).then(response => {
          if (response.data.pagination.current_page === 1) {
            const row_index = this.columnsLabel.map((e) => {
              return e.field
            }).indexOf('rowNumber')
            this.columnsLabel[row_index].footer = {value: response.data.pagination.total}
          }
        })
          .catch(error => {
            if (axios.isCancel(error)) {
              this.$vs.notify({
                title: this.$t('alert.duplicateRequest.title'),
              text: this.$t('alert.duplicateRequest.message'),
                icon: 'icon-alert-circle',
                iconPack: 'feather',
                time: 2400,
                color: 'warning'
              })
            }
          })
      }

      if (this.$refs.usersOpeningBalanceList) this.$refs.usersOpeningBalanceList.setTableData()
    }
  },
  watch: {
    '$store.state.helper.openingBalanceChanged': {
      handler (val) {
        if (val) {
          if (this.insertOpeningInventoryPromptStatus) {
            this.page = 1
            this.data = []
            this.getUsersOpeningBalance()
          }

          if (this.editOpeningInventoryPromptStatus && this.selectedUser) this.refreshUserDetails()

          this.insertOpeningInventoryPromptStatus = false
          this.editOpeningInventoryPromptStatus = false
        }
      },
      deep: true
    },
    '$store.state.helper.openingBalanceDeleted': {
      handler (val) {
        if (val) {
          if (this.editOpeningInventoryPromptStatus && this.selectedUser) this.deleteUserDetails()
          this.editOpeningInventoryPromptStatus = false
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.users-opening-balance-box {
  height: 100%;
}
</style>
